// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__4_MWe","empty":"ModalGraph_empty__18xfm"};